var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"private_wrap"},[_c('p',{staticStyle:{"text-align":"center","font-weight":"bold"}},[_vm._v("糖pai服务协议")]),_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }